import { InjectionToken } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { GridState } from './grid-state.model';

export interface ItemFilterSource {
  getAllItems(
    state: GridState,
    showLegacyItems: boolean,
  ): Observable<GridDataResult>;
}

export const ITEM_FILTER_SOURCE = new InjectionToken<ItemFilterSource>(
  'ITEM_FILTER_SOURCE',
);
